import { BaseFiltersConfig } from 'features/common-elements';

// No Status filter here: openSales only ever returns OPEN sales (the api resolver's own
// contract), so every other status value would just show "no results" -- there's nothing on
// this page for a status filter to usefully narrow.
export const salesFiltersConfig = {
  sale_name: {
    type: 'list-input',
    displayName: 'Sale Name',
  },
} as const satisfies BaseFiltersConfig;

export type SalesFiltersConfig = typeof salesFiltersConfig;
